/**
 * Menu script
 */
 class SW_Menu {
  constructor() {
    this.initState();
    this.initEvents();
  }

  initState() {
    this.win = $(window);
    this.menuWrapper = $('.site-header');
    this.menuIcon = this.menuWrapper.find('.menu-toggle');
    this.menuBlock = this.menuWrapper.find('.menu-block');
    this.mainMenuBlock = this.menuWrapper.find('.main-menu-block');
  }

  initEvents() {
    if (this.menuIcon.length) {
      this.menuIcon.on('click', e => {
        e.preventDefault();
        let menuIconValue = this.menuIcon.attr('aria-expanded');
        this.menuBlock.toggleClass('is-active');
        this.mainMenuBlock.toggleClass('is-active');
        this.menuIcon.toggleClass('is-active');
        this.menuIcon.attr('aria-expanded', 'true');
        $(document.body).toggleClass('no-scroll');

        if ( menuIconValue === 'true') {
          this.menuIcon.attr('aria-expanded', 'false');
        }
      });
    }
  }
}
